import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import ProductGridItem from "../ProductGridItem";
import { getProductsInOffer } from "../../services/ProductService";
import { Link } from "react-router-dom";
import { getLocalData } from "../../utils/localStorage";
import { useSelector, useDispatch } from "react-redux";
import { updateOfferProductWidget } from "../../redux/homePageSlice";

function OfferProductWidget() {
  const items = useSelector((state) => state.homepage.offerProductWidget);
  const dispatch = useDispatch();

  const outletIdM = getLocalData('outlet-id')

  useEffect(() => {
    getProductsInOffer(1, outletIdM ,4).then(
      (res) => {
        dispatch(updateOfferProductWidget(res.products));
      },
      (failure) => {
        console.error(failure); //expected output: Oopsy...
      }
    );
  }, [dispatch]);

  return items.length > 0 ? (
    <section className="brand-sec-margin">
      <div className="container">
        <Row className="pb-2">
          <Col md={6} xs={6} className="d-flex flex-column">
            <span className="header-1 home-sec">Offers for You</span>
            <p className="sub-heading">Shop from selected Featured Products</p>
          </Col>
          <Col md={6} xs={6} className="d-flex align-items-center justify-content-end">
            <Link to={`/allofferrproducts`} className="big-Link">
              SEE ALL Offers
            </Link>
          </Col>
        </Row>
        <Row className="mobile-grid">
          {items.map((product) => {
            return (
              <Col lg={3} md={4} xs={6} key={product.id} className="even-spacer-y">
                <ProductGridItem
                  imgUrl={product.pictureUrl}
                  name={product.name}
                  brand={product.manufacturerName}
                  oldPrice={product.oldPrice}
                  price={product.price}
                  id={product.id}
                  enableWishlist={true}
                />
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  ) : (
    ""
  );
}

export default OfferProductWidget;
